import React, { useContext, useState } from 'react';
import { Col, Flex, Row } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import SoftwarePackageEditDialog from '@totem/components/software/edits/SoftwarePackageEditDialog';
import PackageContext from '@totem/components/software/software_package/packageContext';
import SoftwareEndOfSupport from '@totem/components/software/software_package/softwareEndOfSupport';
import SoftwareTags from '@totem/components/software/software_package/softwareTags';
import HeaderItem from '@totem/components/ui_components/headers/HeaderItem';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import VendorDisplay from '@totem/components/vendors/vendorLogos/vendorDisplay';
import IBDIcon from '@totem/styles/Icon';
import { isNotNull } from '@totem/utilities/common';

const PackageHeader = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { data, onAction } = useContext(PackageContext);
  const [showEdit, setShowEdit] = useState<boolean>(false);

  const handleCancelEdit = (refresh: boolean) => {
    setShowEdit(false);
    if (refresh) {
      onAction('refresh');
    }
  };

  const internalSystemAdministrator =
    permissions.internalSystemAdministrator.hasPermissions(userProfile);

  return (
    <div>
      <Row gutter={20}>
        <Col span={8}>
          <HeaderItem
            title={
              <Flex justify={'space-between'} align={'center'}>
                <div>Publisher</div>
                <div>
                  {internalSystemAdministrator && !showEdit && (
                    <IBTooltip
                      content={permissions.internalSystemAdministrator.tooltip}
                    >
                      <IBDIcon
                        name="Edit"
                        title="Edit Name / Publisher"
                        onClick={() => setShowEdit(true)}
                      />
                    </IBTooltip>
                  )}
                </div>
              </Flex>
            }
          >
            {typeof data !== 'undefined' &&
            data !== null &&
            data.package.publisher !== '' ? (
              <VendorDisplay vendorName={data.package.publisher} />
            ) : (
              'Unknown'
            )}
          </HeaderItem>
        </Col>
        <Col span={8}>
          <SoftwareEndOfSupport />
        </Col>
        <Col span={8}>
          <SoftwareTags />
        </Col>
      </Row>
      {internalSystemAdministrator && showEdit && isNotNull(data) && (
        <SoftwarePackageEditDialog
          visible={internalSystemAdministrator && showEdit && isNotNull(data)}
          onClose={handleCancelEdit}
          packageId={data.package.id}
          packageName={data.package.name}
          packagePublisher={data.package.publisher}
        />
      )}
    </div>
  );
};

export default PackageHeader;
